// Componente de ruta principal que maneja ambos estados de autenticación
// Muestra home-private si está autenticado, o home pública si no lo está

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';
import HomePublic from '../pages/Home';
import { MainLayout } from './Layout';
import { Home } from '../pages/home-private';
import { Radar } from '../pages/radar';

/**
 * Componente HomeRoute
 * 
 * Maneja la ruta principal "/" según el estado de autenticación:
 * - Si está autenticado: muestra Home con MainLayout
 * - Si no está autenticado: muestra HomePublic
 * - Si está cargando: muestra spinner
 */
const HomeRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  // Muestra spinner mientras verifica autenticación
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-900">
        <div className="text-center">
          <LoadingSpinner size="lg" color="white" className="mb-4" />
          <p className="text-gray-200">Completa tu perfil para que otros usuarios te descubran 😉</p>
        </div>
      </div>
    );
  }

  // Si está autenticado, muestra el home privado con layout
  if (isAuthenticated) {
    return (
      <MainLayout>
        <Radar />
      </MainLayout>
    );
  }

  // Si no está autenticado, muestra la home pública
  return <HomePublic />;
};

export default HomeRoute;
